import { render, staticRenderFns } from "./FinanceTrackerGrossRevenueColumn.vue?vue&type=template&id=8f85f2c6&"
import script from "./FinanceTrackerGrossRevenueColumn.vue?vue&type=script&lang=js&"
export * from "./FinanceTrackerGrossRevenueColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports